import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, Dialog, DialogActions, DialogTitle  } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import mainPath from '../../utils/path';

const useStyles = makeStyles((theme) => ({    
  orderListDetailBlock:{
    fontFamily:[
      'Noto Sans KR'
    ],
  },
  row:{
    maxWidth:'1280px', 
    margin:'0 auto', 
    padding:'270px 10px 50px 10px',

    [theme.breakpoints.down(1025)]: {
      padding:'150px 10px 0px 10px',
    }
  },
  orderListDetailH1:{ 
    fontSize:'35px', 
    textAlign:'center', 
    paddingBottom:'40px',
  },
  titles: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '2px solid #007235',
    borderBottom: '2px solid #CCCCCC',
    paddingTop: 12,
    paddingBottom: 12,    
  },
  flexDiv:{
    display:'flex',
    justifyContent:'space-between',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }

  },
  infoDiv:{
    padding:'20px 0 20px 20px ',
    border: '2px solid #007235',
    margin:'100px 0 0px 0',
    width:'600px',

    [theme.breakpoints.down(1025)]: {
      width:'90%',
      margin:'40px auto'
    }

  },
  infoDivH1:{
    fontSize:'20px',
    paddingBottom:'10px',
    textAlign:'center'
  },
  infoDiv2: {
    border: '2px solid #007235',
    margin:'0px auto',
    maxWidth: 1250, 
    minHeight: 50,
    padding:'20px',
    [theme.breakpoints.down(1025)]: {
      width:'90%',
      margin:'40px auto'
    }
  },
  dataBox:{
    display:'flex',
    paddingTop:'10px',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  leftData:{
    width:'120px',
    fontWeight:'500',
    fontSize:'18px'
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',

  },
  leftBtn:{
    width:'100px',
    height:'50px',
    background:'#007235',
    color:'#fff',
    borderRadius:'5px',

    fontFamily:[
      'Noto Sans KR'
    ],

  },
  rightBtn:{
    width:'100px',
    height:'50px',
    background:'#fff',
    color:'#007235',
    border:'1px solid #007235',
    marginLeft:'10px',
    borderRadius:'5px',

    fontFamily:[
      'Noto Sans KR'
    ],

  },


}))


const OrderListDetail = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const classes = useStyles(theme);
  const login = useSelector(state => state.user.login);
  const sendCost = parseInt(useSelector(state => state.config.shopDefaultConfig.de_send_cost_list));
  const [orderResult, setOrderResult] = useState({})
  const [cartResult, setCartResult] = useState([])
  const [dialog, setDialog] = useState('');

  useEffect(() => {
    if (!login) {
      navigate("/");
    }
  } , [login])

  const getItem = async() => {
    try {
        const res = await axios.post('/api/shop/getMyOrderListDetail/', {od_id: location.state.odId})

        if(res.data.success === false) {
            alert('불러오기 실패')
            return;
        }

        setOrderResult(res.data.orderResult)
        setCartResult(res.data.cartResult)
    
      } catch (e) {
        console.log(e)
      }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getItem()
  }, [])

  const editStatus = async() => {
    try {
      const res = await axios.post('/api/adm/orderChangeStatus/', 
      {
        od_id: location.state.odId, 
        mb_id: orderResult.mb_id, 
        od_status: '취소', 
        od_send_cost: sendCost
      } )

      if(res.data.success === false){
        setDialog('실패 하였습니다.')
        return ;
      }

      setDialog('주문이 취소 되었습니다.')
      getItem()
  
    } catch (e) {
      console.log(e)
    }
  } 



  return (
    <div className={classes.orderListDetailBlock}>
        <div className={classes.row}>
          <h1 className={classes.orderListDetailH1}>주문 리스트</h1> 
          <div className={classes.titles}>
            주문 번호  {orderResult['od_id']}
          </div>
          <div>
            {cartResult.length > 0 && cartResult.map((item, index) => (
                <CartItm 
                  key={index}
                  itName={item['it_name']}
                  itImg1={item['it_img1']}
                  ctQty={item['ct_qty']}
                  ctPrice={item['ct_price']}
                  ctStatus={item['ct_status']}
                />
            ))}
          </div>
          <div className={classes.flexDiv}>
            <div className={classes.infoDiv}>
              <h1 className={classes.infoDivH1}>결제정보</h1>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>주문일시</div> 
                <div className={classes.rightData}>
                  {orderResult['od_time'] && orderResult['od_time'].replace('T', ' ')}
                </div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>결제방식</div> 
                <div>{orderResult['od_settle_case']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>결제금액</div> 
                <div>{orderResult['od_cart_price'] && (orderResult['od_cart_price'] + orderResult['od_send_cost']).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>입금자명</div> 
                <div>{orderResult['od_deposit_name']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>입금계좌</div> 
                <div>{orderResult['od_bank_account']}</div>
              </div>
            </div>          
            <div className={classes.infoDiv}>
              <h1 className={classes.infoDivH1}>주문하신 분</h1>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>이름</div> 
                <div>{orderResult['od_name']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>전화번호</div>
                <div>{orderResult['od_tel']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>핸드폰</div> 
                <div>{orderResult['od_hp']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>주소</div> 
                <div>({orderResult['od_zip1'] + orderResult['od_zip2']})  {orderResult['od_addr1'] + orderResult['od_addr2'] + orderResult['od_addr3']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>이메일</div> 
                <div>{orderResult['od_email']}</div>
              </div>
            </div>
          </div>
          <div className={classes.flexDiv}>
            <div className={classes.infoDiv}>
              <h1 className={classes.infoDivH1}>받으시는 분</h1>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>이름</div> 
                <div>{orderResult['od_b_name']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>전화번호</div> 
                <div>{orderResult['od_b_tel']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>핸드폰</div> 
                <div>{orderResult['od_b_hp']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>주소</div> 
                <div>({orderResult['od_b_zip1'] + orderResult['od_b_zip2']})  {orderResult['od_b_addr1'] + orderResult['od_b_addr2'] + orderResult['od_b_addr3']}</div>
              </div>
              <div className={classes.dataBox}>
                <div className={classes.leftData}>희망배송일</div> 
                <div>{orderResult['od_hope_date']}</div>
              </div>
            </div>
            <div className={classes.infoDiv}>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>카트금액</div> 
                  <div>{orderResult['od_cart_price'] && orderResult['od_cart_price'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                </div>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>배송비</div> 
                  <div>{orderResult['od_send_cost'] && orderResult['od_send_cost']}</div>
                </div>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>결제하실 금액</div> 
                  <div>{orderResult['od_cart_price'] && (orderResult['od_cart_price'] + orderResult['od_send_cost'] -  orderResult['od_receipt_point']).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                </div>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>입금금액</div> 
                  <div>{orderResult['od_receipt_price'] && orderResult['od_receipt_price'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                </div>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>포인트</div>  
                  <div>{orderResult['od_receipt_point'] && orderResult['od_receipt_point'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
                </div>
                <div className={classes.dataBox}>
                  <div className={classes.leftData}>결제하신 금액</div> 
                  <div>
                    {orderResult['od_receipt_price'] && (orderResult['od_receipt_price'] + orderResult['od_receipt_point']).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div className={classes.infoDiv2}>
            <p>비고: {orderResult['od_memo']}</p>
        </div>
        <div className={classes.btnDiv}>
        <Button
          onClick={() => navigate("/OrderList")}
          variant="contained"
          style={{
              margin: 20,
              background:'#007235',
              padding:'5px 20px',
              borderRadius:'0',
              fontFamily:[
                'Noto Sans KR'
              ],
          }}
        >
          목록
        </Button>

        {orderResult['od_status'] === '주문' && (
          <Button
            onClick={() => editStatus()}
            style={{
              margin: 20,
            }}
          >
            주문취소
          </Button>
        )}
        </div>

        <Dialog
            open={dialog === '' ? false : true}
            onClose={() => setDialog('')}
        >
          <DialogTitle id="alert-dialog-title">
              {dialog}
          </DialogTitle>
          <DialogActions>
              <Button onClick={() => setDialog('')} autoFocus>
                  확인
              </Button>
          </DialogActions>
        </Dialog>
    </div>
  )
}

const useStylesCart = makeStyles((theme) => ({    
  cartItemBox: {
    display: 'flex',
    alignItems:'center',
    borderBottom: '2px solid #CCCCCC',
  },
  productInformationImg:{
    width:'200px',
    height:'200px',
    marginTop:'20px',
    marginBottom:'20px',
  },
  h3Div:{
    
  },
  cartItem:{
    fontSize:'18px',
    padding:'5px 20px',

    [theme.breakpoints.down(1025)]: {
      fontSize:'12px',
    }
    
  },

}))

const CartItm = ({itName, itImg1, ctQty, ctPrice, ctStatus}) => {
  const theme = useTheme();
  const classes = useStylesCart(theme);




  return (
    <div className={classes.cartItemBox}>
        <img 
            src={`${mainPath}/media/data/item/${itImg1}`}
            className={classes.productInformationImg}
        />
        <div className={classes.h3Div}>
          <h3 className={classes.cartItem}>
            {itName}
          </h3>
          <h3 className={classes.cartItem}>
            {ctQty}
          </h3>
          <h3 className={classes.cartItem}>
            {ctPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </h3>
          <h3 
            className={classes.cartItem}
            style={{ color:'#007235'}}
          >
            {ctStatus}
          </h3>
        </div>
    </div>
  )
}




export default OrderListDetail
